import { FC } from "react";
import ECGEditor from "../../components/Editor";
import { useParams } from "react-router-dom";
import { TaskIdentifier } from "../../data/Tasks/Task";
import { NewMeasurementProvider, useMeasurement } from "../../providers/NewMeasurementProvider";
import { Transition } from "@headlessui/react";
import { MoonLoader } from "react-spinners";
import { CowboyEditor } from "../../components/CowboyEditor/CowboyEditor";
import { CanvasViewportProvider } from "../../components/CowboyEditor/CanvasViewportContext";

export const EditorPage: FC = () => {
    const params = useParams();

    const projectId = params['projectId']!;
    const task = params['task']! as TaskIdentifier;
    const imageId = params['imageId']!;

    return (
        <div>
            <NewMeasurementProvider taskIdentifier={task} projectId={projectId} imageId={imageId}>
                <CanvasViewportProvider>
                    <EditorWrapper imageId={imageId} taskIdentifier={task} projectId={projectId} />
                </CanvasViewportProvider>
            </NewMeasurementProvider>
        </div>
    );
}

const EditorWrapper = (props: { imageId: string, taskIdentifier: TaskIdentifier, projectId: string }) => {
    const { isReady } = useMeasurement();

    return (
        <div className="flex justify-center items-center h-screen">
            <Transition
                show={isReady}
                enter="transition-opacity duration-700"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-700"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                {isReady ? (
                    <div>
                        <CowboyEditor {...props} />
                    </div>
                ) : (
                    <div className="w-full h-full flex justify-center items-center">
                        <MoonLoader size={50} color={"#4A90E2"} loading={!isReady} />
                    </div>
                )}
            </Transition>
        </div>
    );
}

export default EditorPage;